
const shippingBarsInit = () => { 
  const bars = document.querySelectorAll('[data-shipping]');
  if (!bars) {
    return false;
  }
  bars.forEach(bar => {

    const blocks = JSON.parse(bar.dataset.shipping)
    const countries = blocks.split(',').map(country => country.trim())
    const country = countries.includes(window.blubolt.geo.handle)
    if (country === false) {
      bar.classList.add('hide')
    }
  })
}
export default shippingBarsInit